import React from 'react';

const { Provider: UpdateRatedMoviesProvider, Consumer: UpdateRatedMoviesConsumer } = React.createContext();

export { UpdateRatedMoviesProvider, UpdateRatedMoviesConsumer };
